























































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import SigninModel from '@/models/signinModel';
import { displayMessage, apiMessage, inputElement } from '@/constants/signin';

@Component({
  components: { SingleText }
})
export default class Forget extends Vue {
  private signinModel = new SigninModel;
  private isLoading = false;
  private valid = false;
  private email = '';
  private errorMessage = '';
  private define = {};
  private inputElement = {};

  // 外部定義をプロパティーに追加
  created() {
    this.define = displayMessage.forget;
    this.inputElement = inputElement.forget;
  }

  /**
   * パスワード再設定リクエストを送信
   * @returns void
   */
  private async sendForget(): Promise<void> {
    try {
      this.setErrorMessage('');
      this.setLoading(true);

      const response = await this.signinModel.requestPassReset(this.email);

      if ('valid_email' in response && response.valid_email) {
        this.setValid(true);
      } else {
        this.setErrorMessage(apiMessage.noValidEmail);
      }

    } catch($e) {
      this.setErrorMessage(apiMessage.fail);
    } finally {
      this.setLoading(false);
    }
  }

  /**
   * スピナーセット
   * @param {boolean} flg - 表示制御
   * @returns {void}
   */
  private setLoading(flg: boolean): void {
    this.isLoading = flg;
  }

  /**
   * リクエストしたメールアドレスの有効性セット
   * @param {boolean} flg - 有効性
   * @returns {void}
   */
  private setValid(flg: boolean): void {
    this.valid = flg;
  }

  /**
   * エラーメッセージセット
   * @param {string} str - エラーメッセージ
   * @returns {void}
   */
  private setErrorMessage(str: string): void {
    this.errorMessage = str;
  }

}
